// extracted by mini-css-extract-plugin
export default {"cls1":"MAjMHxqTcf0aIhMutkZg","cls2":"n3zltb9a66TtI3Q7BmV0 MAjMHxqTcf0aIhMutkZg"};